import React from 'react'

export default function PageHeader() {
  return (
  <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl text-neutral-800">Page Content Management</h2>
          <p className="text-neutral-600">Manage and update content across all website pages</p>
        </div>
        {/* <button class="bg-neutral-900 text-white px-4 py-2 rounded-md text-sm flex items-center">
          <i class="fa-solid fa-plus mr-2"></i>
          Add New Content
        </button> */}
      </div>
  )
}
